export default __webpack_public_path__ + "static/media/05_card 2.aee5992b.gif";